"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowItemFactoryFromJS = exports.WindowItemFactory = void 0;
const immutable_1 = require("immutable");
const IWindowProperty_1 = require("../../pluginManager/IWindowProperty");
exports.WindowItemFactory = (0, immutable_1.Record)({
    id: null,
    pluginId: null,
    handledPlugin: (0, immutable_1.List)(),
    selectedItems: (0, immutable_1.List)(),
    isActive: null,
    isVisible: null,
    size: null,
    isActivityWindow: null,
    isModified: null,
    isNewVersion: null,
    type: null,
    showLoading: null,
    property: null,
    contentData: (0, immutable_1.Map)(),
    initialContentHash: '',
    openKey: null,
    actionKey: null,
    disableAutoClean: null,
    projectSecretKey: null
});
const WindowItemFactoryFromJS = function (data) {
    return (0, exports.WindowItemFactory)({
        id: data.id,
        pluginId: data.pluginId,
        handledPlugin: (0, immutable_1.List)(data.handledPlugin),
        selectedItems: (0, immutable_1.List)(data.selectedItems),
        isActive: data.isActive,
        isVisible: data.isVisible,
        isNewVersion: data.isNewVersion,
        size: data.size,
        isActivityWindow: data.isActivityWindow,
        isModified: data.isModified,
        type: data.type,
        showLoading: data.showLoading,
        property: (0, IWindowProperty_1.WindowPropertyFactoryFromJS)(data.property),
        contentData: data.contentData,
        initialContentHash: data.initialContentHash,
        openKey: data.openKey,
        actionKey: data.actionKey,
        disableAutoClean: data.disableAutoClean,
        projectSecretKey: data.projectSecretKey
    });
};
exports.WindowItemFactoryFromJS = WindowItemFactoryFromJS;
//# sourceMappingURL=IWindowItem.js.map